import { ISOstring } from "model/modelTypes";
import { TimeRange } from "model/report/dateRange";
import React from "react";

interface DataStatusContextValue {
  dateRange?: TimeRange;
  finishDate?: ISOstring | null;
  statisticsLastUpdated?: Date;
  setDateRange?: (range?: TimeRange) => void;
  setFinishDate?: (date?: ISOstring | null) => void;
  setStatisticsLastUpdated?: (date?: Date) => void;
}

const DataStatusContext = React.createContext<DataStatusContextValue>({});

export const DataStatusProvider = ({ children }) => {
  const [dateRange, setDateRange] = React.useState<TimeRange | undefined>();
  const [finishDate, setFinishDate] = React.useState<
    ISOstring | null | undefined
  >();
  const [statisticsLastUpdated, setStatisticsLastUpdated] = React.useState<
    Date | undefined
  >();

  const value = React.useMemo(
    () => ({
      dateRange,
      finishDate,
      statisticsLastUpdated,
      setDateRange,
      setFinishDate,
      setStatisticsLastUpdated,
    }),
    [dateRange, finishDate, statisticsLastUpdated]
  );

  return (
    <DataStatusContext.Provider value={value}>
      {children}
    </DataStatusContext.Provider>
  );
};

export const useDataStatus = () => {
  const context = React.useContext(DataStatusContext);
  if (!context) {
    throw new Error("useDataStatus must be used within a DataStatusProvider");
  }
  return context;
};

export default DataStatusContext;
